import { type IInfiniteScrollCollectionVm } from '@okcargo-apps/layout-ionic';
import {
  EFreightForCarrierStatus,
  IFreightBasicForCarrier,
  IFreightDetailedForCarrier,
} from '@okcargo-apps/shared-domain';
import { FreightStatus } from '@okcargo/query-processor';

export type IFreightCarrierListVM = IInfiniteScrollCollectionVm<IFreightBasicForCarrier>;

export interface IFreightCarrierDetailedVM {
  item: IFreightDetailedForCarrier | null;
  isLoading: boolean;
  error: Error | undefined;
  /** True when an action that requires the backend cannot be performed (no connectivity). */
  actionsDisabled: boolean;
}

export interface IFreightCarrierFilters {
  driverId?: string;
  reference?: string;
  withoutDigitizedDeliveryNotes?: boolean;
  pendingPaperDeliveryNote?: boolean;
}

export interface IFreightCarrierListQuery {
  uiFilters: IFreightCarrierFilters | null;
}

export interface IAssignationDriverOption {
  id: string;
  label: string;
  isNew?: boolean;
}

export interface IAssignationVehicleOption {
  id: string;
  label: string;
  isNew?: boolean;
}

/** Sentinel ids for the "new driver" / "new vehicle" options. */
export const NEW_ASSIGNATION_DRIVER_ID = '__new_driver__';
export const NEW_ASSIGNATION_VEHICLE_ID = '__new_vehicle__';

/** Sentinel value for the "unselected" option of the assignation selects (sent as explicit null). */
export const NO_ASSIGNATION_SELECTION = '__none__';

// Backend statuses that must not appear in the in-progress list. ABORTED and PLANNING
// are backend values (FreightStatus) without a counterpart in EFreightForCarrierStatus.
export const FREIGHT_CARRIER_IN_PROGRESS_EXCLUDED_STATUSES = [
  EFreightForCarrierStatus.FINISHED,
  EFreightForCarrierStatus.CANCELLED,
  FreightStatus.ABORTED,
  FreightStatus.PLANNING,
].join('|');

export const FREIGHT_CARRIER_DELIVERY_NOTE_TYPE = 'DELIVERY_NOTE';
